var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-box"},on:{"click":function($event){return _vm.Export()}}},[_vm._v("打印")]),_c('files-preview',{ref:"filesPreview"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }